import React, { useState } from "react";
import Button from "../../Button";
import apiInstance from "../../apiInstance";

import { zxcvbn } from "@zxcvbn-ts/core";

const ChangeEmailPwd = ({ data, closePopup, updateError }) => {
    const [emailData, setEmailData] = useState({
        password: "",
    });
    const [passwordStrength, setPasswordStrength] = useState({
        score: 0,
        label: "",
        color: "",
    });
    const [fieldErrors, setFieldErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [statusMessage, setStatusMessage] = useState('');
    const [showCopyConfirmation, setShowCopyConfirmation] = useState(false);

    const validateStrongPassword = (password) => {
        const pwdResult = {};
        const result = zxcvbn(password);
        const score = result.score; // 0–4
        const percent = (score / 4) * 100;
        pwdResult.score = percent;
        if(percent < 90){
            pwdResult.error = 'Weak Password. Please use a strong Password!';
        }
        return pwdResult;
    };

    const getPasswordStrength = (score) => {
        let label = "Weak";
        let color = "red";
        if (score >= 90) {
            label = "Strong";
            color = "green";
        }
        return { score, label, color };
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEmailData((prev) => ({
            ...prev,
            [name]: value,
        }));

        if (name === "password") {
            const passwordErrorsScore = validateStrongPassword(value);
            const strength = getPasswordStrength(passwordErrorsScore.score);
            setPasswordStrength(strength);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const copyPasswordToClipboard = () => {
        navigator.clipboard.writeText(emailData.password).then(() => {
            setShowCopyConfirmation(true);
            setTimeout(() => setShowCopyConfirmation(false), 2000); 
        });
        
    };

    const handleSubmit = async () => {
        setLoading(true);
        updateError("");
        setFieldErrors({});

        const passwordErrors = validateStrongPassword(emailData.password);
        if (passwordErrors.error) {
            setFieldErrors((prev) => ({
                ...prev,
                password: passwordErrors.error
            }));
            setLoading(false);
            return;
        }

        try {
            const currSiteId = data.websiteId;
            const email = data.email;
            const domain = data.domain;
            const password = emailData.password;

            if (email && domain && password && currSiteId) {
                const response = await apiInstance.post(
                    "/dashboard/emails/update",
                    {
                        emailData: {
                            siteId: currSiteId,
                            emailAddress: email,
                            domain: domain,
                            password: password
                        },
                    }
                );

                const status = response.data.status;
                setEmailData({"password": ''})
                setStatusMessage(status);
                // closePopup();
            } else {
                alert("Missing website or password or email address!");
            }
        } catch (error) {
            console.error(`Error:`, error);
            if (error.response) {
                if (
                    error.response.status === 400 &&
                    error.response.data.fieldErrors
                ) {
                    setFieldErrors(error.response.data.fieldErrors);
                } else {
                    updateError(error.response.data?.message || 'Something went wrong, please try again later');
                }
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="mjs-pp">
            <h2>Reset Password</h2>
            <form>

                <div className="mjs-input-field">
                    <label>Email Address</label>
                    <input
                        type="text"
                        name="emailAddress"
                        value={data.email}
                        disabled
                    />
                </div>

                <div className="mjs-input-field">
                    <label htmlFor="password">New Password</label>
                    <div className="mjs-password-input-wrapper">
                        <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter password"
                            id="password"
                            name="password"
                            value={emailData.password}
                            onChange={handleInputChange}
                        />
                        <span className="mjs-password-actions">
                            {showCopyConfirmation && (
                                <span><i className="fa-solid fa-check" style={{color: 'green'}}></i></span>
                            )}
                            <span onClick={copyPasswordToClipboard}><i className="fa-solid fa-copy"></i></span>  
                            <span onClick={togglePasswordVisibility}>
                                <i className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                            </span>                          
                        </span>
                    </div>
                    {fieldErrors.password && (
                        <span className="mjs-error">
                            {fieldErrors.password}
                        </span>
                    )}

                    {emailData.password && (
                        <div className="mjs-password-strength">
                            <div className="mjs-strength-bar">
                                <div
                                    className="mjs-strength-fill"
                                    style={{
                                        width: `${passwordStrength.score}%`,
                                        backgroundColor: passwordStrength.color,
                                    }}
                                />
                            </div>
                            <span
                                className="mjs-strength-label"
                                style={{ color: passwordStrength.color }}
                            >
                                {passwordStrength.label}
                            </span>
                        </div>
                    )}

                    {
                        statusMessage && (
                            <p><i class="mjs_text_green fa-solid fa-circle-check"></i> {statusMessage}</p>
                        )
                    }

                </div>
            </form>

            <div className="mjs-form-actions">
                {loading && <i className="fa-solid fa-spinner fa-spin"></i>}
                <Button name="Reset Password" eventHandler={handleSubmit} />
                <Button name="Cancel" eventHandler={closePopup} />
            </div>
        </div>
    );
};

export default ChangeEmailPwd;
